module.exports = __webpack_public_path__ + "img/flowData.e45a3296.svg";